export default __webpack_public_path__ + "static/media/H0002.1fa10f7d.png";